import { useMutation } from "react-query"
import { axios } from "../../lib/request"
import { useParams } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { useTranslation } from "react-i18next"
import { alertState } from "../../common/AlertDisplay/AlertDisplay.state"

export const useBlastMutation = () => {
    const { game_id } = useParams()
    const { t } = useTranslation()
    const setNotification = useSetRecoilState(alertState)

    return useMutation(
        async ({
            method,
            subject,
            message,
        }) => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_USER_BLAST_URL}/${game_id}/blast.json`,
                {
                  method,
                  subject,
                  message,
                }
            )
            return response
        },
        {
            onSuccess: ({ status }) => {
                if (status === 200) {
                    setNotification({
                      type: "success",
                      message: t("Your blast has been sent."),
                      autoClose: true,
                      closable: true,
                    });
                } else {
                    setNotification({
                        type: "error",
                        message: t("Your blast failed to send."),
                        autoClose: true,
                        closable: true,
                    });
                }
            }
        }
    )
}